const PageNotFound = () => {
  const path = window.location.pathname;
  localStorage.setItem("startPagePath", path.substring(1, path.length));
  window.location.replace("/");
  return <></>;
};

export default PageNotFound;
